import { TextField, Button } from '@material-ui/core'
import React from 'react'
import { useFormik } from 'formik'
import axios from 'axios'
import { useRecoilState } from 'recoil'
import { banksState } from '../recoil/atoms'


const EditBank = props => {
    const [banks, setBanks] = useRecoilState(banksState)
    const formik = useFormik({
        initialValues: {
            name: props.name
        },
        onSubmit: values => {
            axios.put('accounts/bank/', {
                id: props.id,
                name: values.name
            }).then(result => {
                let newData = banks.map(bank => { return { id: bank.id, name: bank.name } })
                newData[newData.findIndex(bank => bank.id === props.id)].name = result.data.name
                setBanks(newData)
                props.setPopup(false)
            })
        }
    })
    return (
        <form onSubmit={formik.handleSubmit}>
            <TextField
                id="name"
                label="نام بانک"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
            />
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: 10 }}
                disabled={formik.isSubmitting}
            >
                ویرایش
            </Button>
        </form>
    )
}

export default EditBank